module.exports = __webpack_public_path__ + "static/media/menu-mobile.b0222942.jpg";